import React, { useState } from 'react'
import { Container } from 'react-bootstrap'
import { get } from 'lodash'
import ReactHtmlParser from 'react-html-parser'
import Typography from 'components/atoms/Typography/Typography'

import './VideoSharepoint.scss'

function extractSharepointUrl(input) {
  if (!input) return ''
  let value = String(input).trim()
  if (!value) return ''

  const iframeSrcMatch = value.match(/src=["']([^"']+)["']/i)
  if (iframeSrcMatch && iframeSrcMatch[1]) {
    value = iframeSrcMatch[1]
  }

  const markdownLinkMatch = value.match(/\((https?:\/\/[^\s)]+)\)/i)
  if (markdownLinkMatch && markdownLinkMatch[1]) {
    value = markdownLinkMatch[1]
  }

  value = value.replace(/^["'\[\]]+|["'\[\]]+$/g, '')

  try {
    const parsed = new URL(value)
    const isSharepointHost = /(^|\.)sharepoint\.com$/i.test(parsed.hostname)
    const isEmbedPath = /\/\_layouts\/15\/embed\.aspx$/i.test(parsed.pathname)

    if (!isSharepointHost || !isEmbedPath) {
      return ''
    }

    return parsed.toString()
  }
  catch (e) {
    return ''
  }
}

function VideoSharepoint({ data }) {
  const title = get(data, 'title')
  const description = get(data, 'description.value')
  const rawUrls = get(data, 'sharepoint_urls') || get(data, 'sharepoint_url') || get(data, 'url')
  const urls = Array.isArray(rawUrls) ? rawUrls : [rawUrls]
  const [erroredIndexes, setErroredIndexes] = useState({})

  const embedUrls = urls.map((url) => extractSharepointUrl(url)).filter(Boolean)

  if (!embedUrls.length) return null

  return (
    <Container className="video-sharepoint" fluid>
      <Container>
        {title && <Typography cssClass="video-sharepoint__title mb-3">{title}</Typography>}
        {description && <div className="video-sharepoint__description mb-3">{ReactHtmlParser(description)}</div>}
        {embedUrls.map((embedUrl, index) => (
          <div className="video-sharepoint__item" key={embedUrl + index}>
            <div className="video-sharepoint__ratio">
              {erroredIndexes[index] ? (
                <div className="video-sharepoint__fallback">
                  <Typography cssClass="video-sharepoint__fallback-title mb-2">
                    Não foi possível carregar o vídeo
                  </Typography>
                  <Typography cssClass="video-sharepoint__fallback-text mb-3">
                    Para assistir, abra o vídeo no SharePoint e faça login com sua conta Microsoft 365.
                  </Typography>
                </div>
              ) : (
                <iframe
                  src={embedUrl}
                  title={title || 'Video SharePoint'}
                  frameBorder="0"
                  scrolling="no"
                  allowFullScreen
                  onError={() => setErroredIndexes((prev) => ({ ...prev, [index]: true }))}
                />
              )}
            </div>
            <div className="video-sharepoint__help mt-3">
              <Typography cssClass="video-sharepoint__hint mb-0">
                Se o vídeo não carregar no bloco acima, abra no SharePoint para autenticar e assistir.
              </Typography>
              <a
                href={embedUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="video-sharepoint__open-link custom-button btn btn-outline-primary btn-lg"
              >
                Abrir no SharePoint
              </a>
            </div>
          </div>
        ))}
      </Container>
    </Container>
  )
}

export default VideoSharepoint
